import { createContext, useContext } from 'react';

var UnleashFeatureFlagsContext = createContext({});
var useUnleashFeatureFlags = function () {
    var context = useContext(UnleashFeatureFlagsContext);
    if (!context) {
        throw new Error('Must use useUnleashFeatureFlags in UnleashFeatureFlagsContext');
    }
    return context;
};

export { UnleashFeatureFlagsContext, useUnleashFeatureFlags };
//# sourceMappingURL=index.es.js.map
